module.exports = __webpack_public_path__ + "static/turtle-creek-house36-46922ea34ff88773e05ef83fa16890a4.jpg";